import { PastYearsSelectHeader } from "../components/elements/DateSelectHeader";
import lookups from "./lookups";

export const TaxCodesFormStages = [
  {
    title: "Tax Codes",
    sections: [
      {
        name: "",
        table: {
          allowAdd: true,
          allowEdit: true,
          allowStatusEdit: true,
          fields: [
            {
              name: "createdon",
              className: "col-date",
              type: "datetime",
            },
            {
              name: "modifiedon",
              className: "col-date",
              type: "datetime",
            },
          ],
          filterByStatus: true,
          filters: [
            {
              name: "createdon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
            {
              name: "modifiedon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
          ],
          linkForNewRecord: "/tax-code",
          lookup: lookups.g4b_taxcode.all,
          useAlphabetPagination: true,
          useSubForm: false,
        },
      },
    ],
  },
];
